module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "abs-autori"
  }, [_c('div', {
    staticClass: "row"
  }, [(false) ? _c('div', {
    staticClass: "col s3"
  }, [_c('el-form-item', [_c('el-input', {
    model: {
      value: (_vm.autore.id),
      callback: function($$v) {
        _vm.$set(_vm.autore, "id", $$v)
      },
      expression: "autore.id"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.cognome
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.autore.cognome),
      callback: function($$v) {
        _vm.$set(_vm.autore, "cognome", $$v)
      },
      expression: "autore.cognome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s5"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.nome
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.autore.nome),
      callback: function($$v) {
        _vm.$set(_vm.autore, "nome", $$v)
      },
      expression: "autore.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s10"
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.affiliazione
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.autore.affiliazione),
      callback: function($$v) {
        _vm.$set(_vm.autore, "affiliazione", $$v)
      },
      expression: "autore.affiliazione"
    }
  }, _vm._l((_vm.$teras.affiliazioni), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s2"
  }, [(_vm.autore.id == -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.aggiungi,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autore.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.salvamodifiche,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "edit"
    },
    on: {
      "click": _vm.editNow
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autore.id > -1) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$teras.lang.cancella,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "delete"
    },
    on: {
      "click": _vm.delNow
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.$teras.autori.length > 0) ? _c('div', {
    staticClass: "row pad help"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col s10",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.autoriOrderHelp)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$teras.autori.length > 0) ? _c('draggable', {
    staticClass: "dragArea",
    attrs: {
      "list": _vm.$teras.autori
    },
    on: {
      "end": _vm.onEnd
    }
  }, _vm._l((_vm.$teras.autori), function(element, index) {
    return _c('div', {
      key: element.id,
      on: {
        "click": function($event) {
          return _vm.onEdit(element)
        }
      }
    }, [_vm._v(_vm._s(index + 1) + " " + _vm._s(element.cognome) + " " + _vm._s(element.nome) + " "), _c('sup', [_vm._v(_vm._s(_vm.affiliazione(element.affiliazione)))])])
  }), 0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s2 yo-align-right"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("live_help")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62560751"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-autori.vue
// module id = 609
// module chunks = 2